<template>
  <div class="login-page">
    <img
      src="../../assets/images/city-background.jpg"
      alt="contact-image"
      class="image-background-login"
    />
    <LoginForm />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import LoginForm from "../../components/Authentication/LoginForm.vue";

export default defineComponent({
  name: "LoginPage",
  components: {
    LoginForm,
  },
});
</script>

<style scoped>
@media only screen and (max-width: 767px) {
  .login-page {
    height: 100vh;
    height: 100dvh;
    inset: 0;
    overflow: hidden;
    position: fixed;
    width: 100%;
  }
}
</style>
